import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import ru from "./locales/ru.json";
i18n.use(initReactI18next).init({
  lng: "ru",
  fallbackLng: "ru",
  keySeparator: false,
  nsSeparator: false,
  resources: { ru: { translation: ru } },
  interpolation: { escapeValue: false },
});
export const tr = (key: string) => i18n.t(key, { defaultValue: key });
